module.exports = __webpack_public_path__ + "img/album19_05.e5e1509d.jpg";